export class PropertyFeatures{
    public beds?:number;
    public baths?:number;
    public garages?:number;
    public areaFrom?:number;
    public areaTo?:number;

    public get definedFeatures(){
        let result:number=0;
        if(this.beds) result++;
        if(this.baths) result++;
        if(this.garages) result++;
        if(this.areaFrom || this.areaTo) result++;
        return result;
    }

    public clear(){
        this.beds=undefined;
        this.baths=undefined;
        this.garages=undefined;
        this.areaFrom=undefined;
        this.areaTo=undefined;
    }
}